import { LANGUAGES, type Lang } from "@/app/i18n/types";

/** Chuẩn hoá về object từ string/array/object bất kỳ. */
export function toMlObj(v: unknown): Partial<Record<Lang, string | string[]>> {
  if (v && typeof v === "object" && !Array.isArray(v)) {
    return { ...(v as Record<string, unknown>) } as Partial<
      Record<Lang, string | string[]>
    >;
  }
  if (v != null && v !== "") {
    if (Array.isArray(v)) return { vi: v as string[] };
    return { vi: String(v) };
  }
  return {};
}

/** Lấy 1 chuỗi hiển thị theo ngôn ngữ. */
export function pick(v: unknown, lang: Lang): string {
  if (v == null) return "";
  if (typeof v === "string") return v;
  if (typeof v === "object" && !Array.isArray(v)) {
    const o = v as Record<string, unknown>;
    for (const l of [lang, "vi", "en", "ja"] as const) {
      const x = o[l];
      if (typeof x === "string" && x) return x;
    }
    for (const k of Object.keys(o)) {
      const x = o[k];
      if (typeof x === "string" && x) return x;
    }
  }
  return "";
}

/** Chuẩn hoá từ form (object {vi,en,ja}) → undefined nếu tất cả trống
 *  (để PATCH giữ field cũ). */
export function stripEmpty(
  o: Partial<Record<Lang, string>>
): Partial<Record<Lang, string>> | undefined {
  const out: Partial<Record<Lang, string>> = {};
  for (const lg of LANGUAGES) {
    const v = o[lg]?.trim();
    if (v) out[lg] = v;
  }
  return Object.keys(out).length ? out : undefined;
}

/** Tương tự stripEmpty nhưng tách dòng (cho features list). */
export function stripEmptyFeatures(
  o: Partial<Record<Lang, string>>
): Partial<Record<Lang, string[]>> | undefined {
  const out: Partial<Record<Lang, string[]>> = {};
  for (const lg of LANGUAGES) {
    const v = o[lg];
    if (!v) continue;
    const arr = v
      .split("\n")
      .map((s) => s.trim())
      .filter(Boolean);
    if (arr.length) out[lg] = arr;
  }
  return Object.keys(out).length ? out : undefined;
}
